import { combineReducers } from "redux";
import dashboardReducer from './dashboardReducer';
import languageReducer from './languageReducer';
import spreadsheetReducer from './spreadsheetReducer'

export default combineReducers({
    dashboard: dashboardReducer,
    language: languageReducer,
    spreadsheet: spreadsheetReducer
})